import { createTrackAction } from './create'

export const track = {
  create: createTrackAction,
}
